export default __webpack_public_path__ + "favicons/mstile-144x144.png";